import BluBlocksButton from "components/buttons/Button"
import styled from "styled-components"
import motionTokens from "styles/motionTokens"

export const Button = styled(BluBlocksButton)`
  height: 30px;
  padding: 0;
  padding-left: 2px;
  width: 30px;

  &:hover {
    border: none;
  }

  &:hover svg,
  &:focus-visible svg {
    transform: scale(${motionTokens.scale.strong});
  }

  &:active svg {
    transform: scale(${motionTokens.press.medium});
  }
`
